var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 498.648 498.648",
    style: {
      enableBackground: "new 0 0 498.648 498.648"
    },
    xmlSpace: "preserve",
    width: "25px",
    height: "33px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7976"
    },
    d: "M254.956,0C179.332,0,111.908,33.168,66.228,85.752c-13.92,16.04-25.848,33.856-35.336,53.128  l84.008,64.168c9.736-29.544,28.536-54.896,53.12-72.832C192.364,112.48,222.38,102,254.948,102  c35.184,0,66.96,12.472,91.928,32.872l72.632-72.528C375.26,23.8,318.516,0,254.956,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3443A"
    },
    d: "M30.9,138.872l84.008,64.168c9.736-29.544,28.536-54.896,53.12-72.832  c24.344-17.736,54.36-28.216,86.928-28.216c35.184,0,66.96,12.472,91.928,32.872l72.632-72.528C375.252,23.808,318.516,0,254.956,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D72C"
    },
    d: "M107.428,249.32c0-2.296,0.168-4.56,0.272-6.832c0.656-13.728,3.096-26.96,7.208-39.448L30.9,138.872  C15.452,170.208,6.492,205.296,5.484,242.488c-0.064,2.28-0.2,4.544-0.2,6.832c0,2.296,0.136,4.568,0.192,6.848  c1.008,37.144,9.968,72.216,25.376,103.52l83.984-64.288c-4.072-12.424-6.496-25.6-7.136-39.24  C107.596,253.888,107.428,251.624,107.428,249.32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B92B"
    },
    d: "M30.86,359.688l83.984-64.288c-4.072-12.424-6.496-25.6-7.136-39.24   c-0.104-2.28-0.272-4.544-0.272-6.848c0-2.296,0.168-4.56,0.272-6.832c0.656-13.728,3.096-26.96,7.208-39.448L30.9,138.872"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59C96E"
    },
    d: "M337.876,374.848c-22.504,14.176-50.848,21.8-82.92,21.8c-18.768,0-36.648-3.568-53.128-9.912  c-12.136-4.672-23.464-10.92-33.808-18.44c-24.576-17.896-43.384-43.168-53.12-72.688l-84.008,64.16  c9.472,19.24,21.376,37.032,35.272,53.048c45.68,52.64,113.152,85.832,188.792,85.832c22.88,0,45.368-3.056,66.84-9.008  c35.696-9.904,68.592-27.832,95.832-53.128L337.876,374.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40A557"
    },
    d: "M30.9,359.768c9.472,19.24,21.376,37.032,35.272,53.048c45.68,52.64,113.152,85.832,188.792,85.832  c22.88,0,45.368-3.056,66.84-9.008c35.696-9.904,68.592-27.832,95.832-53.128l-79.76-61.656c-22.504,14.176-50.848,21.8-82.92,21.8  c-18.768,0-36.648-3.568-53.128-9.912c-12.136-4.672-23.464-10.92-33.808-18.44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FAEF4"
    },
    d: "M487.612,201.32h-14.968h-215.36v41.168v13.68v41.152h131.592c-6.696,32-24.92,61.088-51,77.528  l79.76,61.656c21.872-20.304,40.04-45.784,53.112-75.256c14.336-32.288,22.536-70.96,22.536-113.456  C493.284,233.072,491.02,217.32,487.612,201.32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4087ED"
    },
    d: "M417.636,436.504c21.872-20.304,40.2-46.072,53.272-75.544   c14.336-32.288,22.456-70.816,22.456-113.304c0-14.728-2.344-30.336-5.752-46.336h-14.328"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#4087ED"
    },
    points: "257.284,241.32 257.284,256.168 257.284,297.32 385.284,297.32  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8ac3dd58eb1b09402b5aff8e35fd3440.svg";
export { ForwardRef as ReactComponent };